<template>
  <div ref="item" class="container">
    <div class="label">{{ label }}</div>
    <div>
      <AnimatedNumber
        class="number"
        :formatValue="formatNumber"
        :value="value"
        :duration="1000"
      />
      <span class="unit">{{ unit }}</span>
    </div>
  </div>
</template>

<script>
import AnimatedNumber from "animated-number-vue";

export default {
  components: {
    AnimatedNumber
  },
  props: {
    label: String,
    number: Number,
    unit: String
  },
  data() {
    return {
      value: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", this.setValueWhenDisplayed);
    window.addEventListener("load", this.setValueWhenDisplayed);
  },
  methods: {
    formatNumber(value) {
      return value.toFixed(0);
    },
    setValueWhenDisplayed() {
      const displayedHeightArea = window.scrollY + window.innerHeight;
      if (displayedHeightArea > this.$refs.item.offsetTop) {
        this.value = this.number;
        window.removeEventListener("scroll", this.setValueWhenDisplayed);
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.setValueWhenDisplayed);
    window.removeEventListener("load", this.setValueWhenDisplayed);
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 152px;
  width: 152px;
  border-radius: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #1c2e53;
  font-weight: bold;

  .label {
    font-size: 20px;
  }

  .number {
    font-size: 43px;
    display: inline;
  }

  .unit {
    font-size: 24px;
  }
}

@media (max-width: 1023px) {
  .container {
    width: 90px !important;
    height: 90px !important;
  }

  .label {
    font-size: 12px !important;
  }

  .number {
    font-size: 24px !important;
  }

  .unit {
    font-size: 12px !important;
  }
}
</style>
